<template>
  <form
    class="form-work-day"
    v-on:reset.prevent="emitCancel"
    v-on:submit.prevent="onSubmit"
  >
    <time
      class="form-work-day__date"
      v-bind:datetime="datetime"
    >{{ dateTitle }}</time>
    <label class="form-work-day__checkbox">
      <input
        type="checkbox"
        v-bind:disabled="!hasEditSchedule"
        v-model="isOffDay" />
      <span>Выходной</span>
    </label>
    <div class="form-work-day__row">
      <input
        class="form-work-day__input"
        v-bind:disabled="isOffDay || !hasEditSchedule"
        v-mask="$options.maskTime"
        v-model="from" />
      —
      <input
        class="form-work-day__input"
        v-bind:disabled="isOffDay || !hasEditSchedule"
        v-mask="$options.maskTime"
        v-model="to" />
    </div>
    <div class="form-work-day__buttons" v-if="hasEditSchedule">
      <button
        class="form-work-day__cancel"
        type="button"
        v-on:click="emitCancel"
      >Отмена</button>
      <button
        class="form-work-day__submit"
        type="submit"
      >ОК</button>
    </div>
  </form>
</template>
<script>

/**
 * @description Компонент формы редактирования рабочего дня.
 * @type {Vue}
 */
export default {
  data() {
    return {
      from: this.initialFrom,
      isOffDay: false,
      to: this.initialTo,
    };
  },
  maskTime: '##:##',
  methods: {
    emitCancel() {
      this.$emit('cancel');
    },
    onSubmit() {
      const output = {
        date: this.datetime,
        from: this.from,
        isOff: this.isOffDay,
        to: this.to,
      };
      this.$emit('submit', output);
    },
  },
  name: 'FormWorkDay',
  props: {
    /**
     * @description Заголовок даты.
     * @type {String}
     */
    dateTitle: { required: true, type: String },
    /**
     * @description Дата и время в формате ISO.
     * @type {String}
     */
    datetime: { required: true, type: String },
    /**
     * @description Может редактировать график работы.
     * @type {boolean}
     */
    hasEditSchedule: { required: true, type: Boolean },
    /**
     * @description Время начала рабочего дня.
     * @type {string}
     */
    initialFrom: { type: String, default: '00:00' },
    /**
     * @description Время окончания рабочего дня.
     * @type {string}
     */
    initialTo: { type: String, default: '00:00' },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";
$button-font-size: 14px;
$button-height: 37px;
$button-width: 100%;
.form-work-day {
  padding: 15px 20px 27px;
  width: 245px;
  max-width: 99%;
  display: flex;
  flex-direction: column;
  &__date {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #707683;
    margin: 0 0 20px 0;
  }
  &__checkbox>input {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }
  &__checkbox>span {
    display: inline-flex;
    align-items: center;
    user-select: none;
    cursor: pointer;
  }
  &__checkbox>span::before {
    content: '';
    display: inline-block;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    flex-grow: 0;
    border: 1px solid #90A0B7;
    border-radius: 4px;
    margin-right: 6px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 70%;
    background-color: #ffffff;
  }
  &__checkbox>input:not(:disabled):not(:checked)+span:hover::before {
    border-color: #0489e0;
  }
  &__checkbox>input:checked+span::before {
    cursor: pointer;
    background-color: #0489e0;
    border-color: #0489e0;
    background-image: url("@/assets/img/checked/checked-white-top.svg");
  }
  &__row {
    display: grid;
    grid-template-columns: 1fr 10px 1fr;
    grid-gap: 10px;
    align-items: center;
    margin: 20px 0 0 0;
  }
  &__input {
    border: 1px solid #C2CFE0;
    box-sizing: border-box;
    border-radius: 4px;
    height: 40px;
    width: 100%;
    padding: 10px;
    color: #707683;
    font-size: 16px;
    &:focus {
      color: #192a3e;
      background-color: #fff;
      border: 1px solid #0489e0 !important;
      outline: 0;
    }
    &:disabled {
      background-color: #fff;
    }
  }
  &__buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 30px 0 0 0;
  }
  &__cancel {
    @include buttons.btn-transparent($button-width, $button-height, $button-font-size);
  }
  &__submit {
    @include buttons.btn-blue($button-width, $button-height, $button-font-size);
  }
}
</style>
